import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lc_ttop"
};
const _hoisted_2 = {
  class: "lc-bsinfo"
};
const _hoisted_3 = {
  style: {
    "padding-bottom": "50px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LcButtons = _resolveComponent("LcButtons");
  const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
  const _component_Lcggdytab = _resolveComponent("Lcggdytab");
  const _component_lcwjsc = _resolveComponent("lcwjsc");
  const _component_lctinymce = _resolveComponent("lctinymce");
  const _component_LcWriteLinks = _resolveComponent("LcWriteLinks");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lc_rw"
  }, {
    default: _withCtx(() => [_createVNode(_component_LcButtons, {
      ref: "lcButtons",
      type: 2,
      onBtsEmit: _cache[0] || (_cache[0] = $event => _ctx.btsEmit($event)),
      planStratTime: _ctx.data.baseInfo.plan_start_time_text,
      ids: _ctx.ids,
      projectName: _ctx.data.baseInfo.project_name,
      reviewerUserId: _ctx.data.baseInfo.reviewer_user_id,
      userId: _ctx.data.baseInfo.leader_user_id,
      msg: _ctx.data.baseInfo.msg,
      onGetPageInfo: _ctx.getPageInfo,
      deppgetPageInfo: _ctx.getPageInfo
    }, null, 8, ["planStratTime", "ids", "projectName", "reviewerUserId", "userId", "msg", "onGetPageInfo", "deppgetPageInfo"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_lcBaseInfo, {
      ref: "addBaseInfo",
      type: "taskInfo"
    }, null, 512)]), _createElementVNode("div", _hoisted_2, [_cache[11] || (_cache[11] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "输入文件", -1)), _cache[12] || (_cache[12] = _createElementVNode("div", {
      class: "lc_title1"
    }, "规格定义表", -1)), _createVNode(_component_Lcggdytab, {
      ggdyTableData: _ctx.data.ggdyTableData,
      "onUpdate:ggdyTableData": _cache[1] || (_cache[1] = $event => _ctx.data.ggdyTableData = $event),
      nobts: ['add', 'delet'],
      prtaskId: _ctx.ids,
      pageTag: "xxlr"
    }, null, 8, ["ggdyTableData", "prtaskId"]), _cache[13] || (_cache[13] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "输出文件", -1)), _createVNode(_component_lcwjsc, {
      loading: _ctx.fbhpptdata.loading,
      "onUpdate:loading": _cache[2] || (_cache[2] = $event => _ctx.fbhpptdata.loading = $event),
      tableHeigth: _ctx.fbhpptdata.tableHeigth,
      "onUpdate:tableHeigth": _cache[3] || (_cache[3] = $event => _ctx.fbhpptdata.tableHeigth = $event),
      listHeader: _ctx.fbhpptdata.listHeader,
      "onUpdate:listHeader": _cache[4] || (_cache[4] = $event => _ctx.fbhpptdata.listHeader = $event),
      defaultRow: _ctx.fbhpptdata.defaultRow,
      "onUpdate:defaultRow": _cache[5] || (_cache[5] = $event => _ctx.fbhpptdata.defaultRow = $event),
      tableHeader: _ctx.fbhpptdata.tableHeader,
      "onUpdate:tableHeader": _cache[6] || (_cache[6] = $event => _ctx.fbhpptdata.tableHeader = $event),
      notShowCol: _ctx.fbhpptdata.notShowCol,
      "onUpdate:notShowCol": _cache[7] || (_cache[7] = $event => _ctx.fbhpptdata.notShowCol = $event),
      staticList: _ctx.fbhpptdata.staticList,
      "onUpdate:staticList": _cache[8] || (_cache[8] = $event => _ctx.fbhpptdata.staticList = $event),
      beforeStrList: _ctx.fbhpptdata.beforeStrList,
      "onUpdate:beforeStrList": _cache[9] || (_cache[9] = $event => _ctx.fbhpptdata.beforeStrList = $event),
      onGetClickBtnType: _ctx.getClickBtnType_ggdyppt,
      onUploadAddRow: _ctx.uploadAddRow
    }, null, 8, ["loading", "tableHeigth", "listHeader", "defaultRow", "tableHeader", "notShowCol", "staticList", "beforeStrList", "onGetClickBtnType", "onUploadAddRow"]), _cache[14] || (_cache[14] = _createElementVNode("div", {
      class: "lc_ttop lc_bzt"
    }, "备注", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_lctinymce, {
      id: _ctx.data.id,
      ref: "editor",
      height: _ctx.data.height,
      "cur-value": _ctx.data.remark,
      onInput: _ctx.inputContent,
      key: _ctx.data.key
    }, null, 8, ["id", "height", "cur-value", "onInput"]))])]), (_openBlock(), _createBlock(_component_LcWriteLinks, {
      key: _ctx.fbhpptdata.isShowLinksDialogIndex,
      isShowLinksDialog: _ctx.fbhpptdata.isShowLinksDialog,
      "onUpdate:isShowLinksDialog": _cache[10] || (_cache[10] = $event => _ctx.fbhpptdata.isShowLinksDialog = $event),
      onGetDragWriteData: _ctx.getDragWriteData
    }, null, 8, ["isShowLinksDialog", "onGetDragWriteData"]))]),
    _: 1
  });
}